module.exports = __webpack_public_path__ + "media/images/logotipo_mini-6662ad09cc8c01a411763bdd51f7d874.svg";